import { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import AppointmentManagement from "./Appointmentmanager";
import PetServices from "./PetServicesManager";
import TodayAppointments from "./TodayAppointments";


const appointmentCategories = [
    { label: "Veterinarian Appointments", value: "teleconsult" },
    { label: "Service Appointments", value: "service" },
    { label: "Today's Appointments", value: "today" },
];

interface AppointmentsPageProps {
    initialCategory?: string;
}


export default function AppointmentsPage({ initialCategory }: AppointmentsPageProps) {
    const [selectedCategory, setSelectedCategory] = useState<string>("teleconsult");

    useEffect(() => {
        if (initialCategory) {
            setSelectedCategory(initialCategory);
        }
    }, [initialCategory]);
    
    const renderAppointments = () => {
        switch (selectedCategory) {
            case "teleconsult":
                return <AppointmentManagement />;
            case "service":
                return <PetServices />;
            case "today":
                return <TodayAppointments />;
            default:
                return <p>Select a category to view appointments.</p>;
        }
    };

    return (
        <Layout>
            <div className="p-6">
                {/* Toggle Buttons */}
                <div className="flex gap-3 mb-6">
                    {appointmentCategories.map((cat) => (
                        <button
                            key={cat.value}
                            onClick={() => setSelectedCategory(cat.value)}
                            className={`px-4 py-2 rounded-lg border text-sm font-medium ${selectedCategory === cat.value
                                ? "bg-black text-white"
                                : "bg-white hover:bg-gray-100"
                                }`}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>

                {/* Render Appointment List */}
                <div>{renderAppointments()}</div>
            </div>
        </Layout>
    );
}
